export const normalizarEmail = (email) => (email || "").trim();

export const normalizarTelefono = (telefono) => (telefono || "").trim();

/**
 * Retorna true si el email es válido, false en caso contrario.
 * El email vacío se considera inválido (obligatorio).
 */
export const validarEmail = (email) => {
    const correo = normalizarEmail(email);
    if (!correo) return false;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(correo);
};

/**
 * Valida un teléfono internacional completo (código de país + número).
 * El campo puede ir vacío; si tiene valor se respeta el máximo E.164 de 15 dígitos.
 */
export const validarTelefonoInternacional = (telefono) => {
    const telefonoNormalizado = normalizarTelefono(telefono);
    const telefonoLimpio = telefonoNormalizado.replace(/\D/g, "");

    if (!telefonoLimpio) return true;
    return telefonoLimpio.length >= 7 && telefonoLimpio.length <= 15;
};

// Compatibilidad temporal para consumidores que aún importan el nombre anterior.
export const validarTelefonoChileno = validarTelefonoInternacional;

export const getPasswordStrength = (value) => {
    const password = value || "";
    let score = 0;

    if (password.length >= 8) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[a-z]/.test(password)) score++;
    if (/[0-9]/.test(password)) score++;
    if (/[^A-Za-z0-9]/.test(password)) score++;

    let label = "Débil";
    let color = "#dc3545";

    if (score >= 3 && score <= 4) {
        label = "Media";
        color = "#ffc107";
    } else if (score >= 5) {
        label = "Fuerte";
        color = "#28a745";
    }

    const percent = Math.min(score * 20, 100);

    return { label, color, value: percent };
};